import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '../../../globals';

declare var $;
declare function info_noti(msg:any):any;
@Component({
  selector: 'app-vital',
  templateUrl: './vital.component.html',
  styleUrls: ['./vital.component.css']
})
export class VitalComponent implements OnInit {
  showActions: boolean = false;
  constructor(private route: Router, private chRef: ChangeDetectorRef,private global:Globals) { }

  ngOnInit() {
    this.global.afterRefreshPageSetToken();
    this.chRef.detectChanges();
    $("#vitalDatatable").DataTable({
      "paging": false,
      "info": false
    });
    $("#vitalDatatable_filter").hide();
  }

  ManageColumns(event) {
    $("." + event.target.value).toggle();
  }

  ViewVital() {
    debugger;
    var employeeObjects = [];
    var tables = $('#vitalDatatable').DataTable().rows().data();
    for (var i = 0; i < tables.length; i++) {
      employeeObjects.push(tables[i]);
    }
    this.route.navigate(['/dashboard/vitalchart']);
  }
}
